import { mapGetters, mapActions, mapMutations } from "vuex";

import * as dealersStore from "@/store/Dealers";

export { dealersStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createDealersMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(dealersStore.moduleName, Object.keys(dealersStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(dealersStore.moduleName, Object.keys(dealersStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(dealersStore.moduleName, Object.keys(dealersStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
